<template>
  <d2-container>
    <top-line :message="pageTitle" :iconclass="'fa fa-users'"></top-line>
    <div class="container" style="padding: 20px;">
      <!-- 第一部分：统计信息 -->
      <div style="margin-bottom: 10px; padding: 20px; background-color: #fff; border-radius: 8px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);">
        <div style="font-size: 16px; font-weight: bold; margin-bottom: 12px; color: #333;">
          设备已占用数量：{{ totalUsedDevices }}台
        </div>
        <div style="display: flex; flex-wrap: wrap; gap: 16px;">
          <div v-for="(item, index) in stats" :key="index" style="padding: 8px 16px;">
            <span style="font-weight: 500;">{{ item.spec_type }}</span>已占用：
            <span style="font-weight: bold; color: #1890ff;">{{ item.device_count }}</span>台
          </div>
        </div>
      </div>

      <!-- 第二部分：订单列表 -->
      <el-card class="box-card" style="margin-bottom: 20px;">
        <div slot="header" class="clearfix">
          <span style="font-size: 18px; font-weight: bold;">算力使用列表</span>
        </div>
        <!-- 搜索表单 -->
        <div class="search-form" style="margin-bottom: 20px;">
          <el-form :inline="true" :model="searchForm" size="small">
            <el-form-item label="订单名称：">
              <el-input v-model="searchForm.order_name" placeholder="请输入订单名称" style="width: 200px;"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSearch">查询</el-button>
              <el-button @click="handleReset">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table 
          :data="orders" 
          border 
          style="width: 100%"
        >
          <el-table-column 
            prop="order_name" 
            label="订单名称" 
            sortable 
          />
          <el-table-column 
            prop="delivery_name" 
            label="交付名称" 
            sortable 
          />
          <el-table-column 
            prop="host_ip" 
            label="设备IP" 
            sortable
            width="140"
          />
          <el-table-column 
            prop="hostname" 
            label="设备名称" 
            sortable
            width="120"
          />
          <el-table-column 
            prop="status" 
            label="状态" 
            sortable
            width="100"
          >
            <template #default="scope">
              <el-tag 
                :type="scope.row.status === 0 ? 'success' : 'info'"
                size="small"
              >
                {{ scope.row.status === 0 ? '已交付' : '已回收' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column 
            prop="order_start_date" 
            label="开始时间"
            width="120"
            :formatter="formatDate" 
          />
          <el-table-column 
            prop="order_end_date" 
            label="结束时间" 
             width="120"
            :formatter="formatDate" 
          />
          <el-table-column 
            prop="delivery_time" 
            label="交付时间" 
             width="120"
            :formatter="formatDate" 
          />
          <el-table-column 
            prop="recycle_time" 
            label="回收时间" 
             width="120"
            :formatter="formatDate" 
          />
        </el-table>
        <!-- 分页控件 -->
        <div class="pagination-wrapper" style="margin-top: 20px; text-align: right;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pagination.page"
            :page-sizes="pagination.pageSizeList"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total">
          </el-pagination>
        </div>
      </el-card>
    </div>
  </d2-container>
</template>

<script>
import topLine from "@/components/save-common/topLine.vue";

export default {
  name: 'DeviceDashboard',
  components: {
    topLine,
  },
  data() {
    return {
      pageTitle: "算力使用情况",
      stats: [],
      orders: [],
      searchForm: {
        order_name: ''
      },
      pagination: {
        page: 1,
        pageSize: 10,
        pageSizeList: [10, 20, 50, 100],
        total: 0
      }
    };
  },
  computed: {
    // 计算设备已占用总数量
    totalUsedDevices() {
      return this.stats.reduce((sum, item) => sum + (item.device_count || 0), 0);
    }
  },
  created() {
    this.fetchUsageStats();
    this.fetchOrders();
  },
  methods: {
    formatDate(row, column, cellValue) {
      const value = cellValue || row.start_time || row.end_time;
      if (!value) return '';
      return value.substring(0, 10);
    },
    async fetchUsageStats() {
      try {
        const params = {
          order_name: this.searchForm.order_name
        };
        const res = await this.$axios.get('/api-30216/api/user-orders/stats', { params });
        if (res.code === 200) {
          console.log(res.data);
          this.stats = Array.isArray(res.data) ? res.data : [];
        } else {
          this.$message.error('获取设备统计失败: ' + res.message);
        }
      } catch (err) {
        // this.$message.error('请求失败: ' + err.message);
      }
    },
    async fetchOrders() {
      try {
        const params = {
          page: this.pagination.page,
          pageSize: this.pagination.pageSize,
          order_name: this.searchForm.order_name
        };
        const res = await this.$axios.get('/api-30216/api/user-orders', { params });
        if (res.code === 200) {
          this.orders = res.data || [];
          this.pagination.total = res.total || 0;
        } else {
          this.$message.error('获取订单失败: ' + res.message);
        }
      } catch (err) {
        // this.$message.error('请求失败: ' + err.message);
      }
    },
    handleSearch() {
      this.pagination.page = 1;
      this.fetchUsageStats();
      this.fetchOrders();
    },
    handleReset() {
      this.searchForm = { order_name: '' };
      this.pagination.page = 1;
      this.fetchUsageStats();
      this.fetchOrders();
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.fetchOrders();
    },
    handleCurrentChange(page) {
      this.pagination.page = page;
      this.fetchOrders();
    }
  }
};
</script>

<style scoped>
.container {
  margin: 0 auto;
}
.stats-row {
  display: flex;
  justify-content: space-between;
}
.stat-item {
  flex: 1;
  text-align: center;
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 8px;
  margin: 0 5px;
  background-color: #f9f9f9;
  height: 90px;
}
.value {
  font-size: 24px;
  font-weight: bold;
}
.clearfix {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  flex-wrap: wrap;
}
.clearfix > span,
.clearfix > .el-tag {
  line-height: 24px;
}
</style>